module.exports = __webpack_public_path__ + "img/流体力学4_5_2.c7dfd3ab.jpg";